import { Instagram } from "lucide-react";
import { Squiggle, Sparkle } from "./Decorations";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-white text-charcoal pt-20 pb-10 overflow-hidden border-t border-lavender/40"
    >
      {/* Soft lavender backdrop wash */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-50 pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(50% 50% at 50% 0%, rgba(199,165,217,0.25), transparent 60%), radial-gradient(40% 50% at 90% 100%, rgba(149,196,211,0.18), transparent 60%)",
        }}
      />
      {/* Rotating soft halo behind the seal */}
      <div
        aria-hidden
        className="absolute left-1/2 top-12 -translate-x-1/2 w-80 h-80 rounded-full pointer-events-none"
        style={{
          background:
            "conic-gradient(from 0deg, rgba(199,165,217,0.45), transparent 35%, rgba(149,196,211,0.35) 60%, transparent 90%, rgba(199,165,217,0.45))",
          filter: "blur(32px)",
          animation: "spin 22s linear infinite",
        }}
      />

      <Sparkle className="absolute top-16 left-1/4" color="#8E44AD" size={18} />
      <Sparkle className="absolute bottom-24 right-1/4" color="#C7A5D9" size={14} />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-10">
        <div className="flex flex-col items-center text-center gap-5">
          <img
            src="/images/logo-seal.webp"
            alt="Dr. Maggie Cadet, MD, Rheumatologist seal"
            width="391"
            height="224"
            decoding="async"
            className="h-48 sm:h-56 w-auto object-contain hover:scale-105 hover:rotate-2 transition-transform duration-700"
            loading="lazy"
          />
          <div className="h-display text-[12px] tracking-[0.32em] text-plum mt-2">
            Rheumatology . Joint Health . Autoimmune Education
          </div>

          <div className="max-w-[260px] mx-auto opacity-70">
            <Squiggle color="#8E44AD" />
          </div>

          <a
            data-testid="footer-instagram"
            href="https://www.instagram.com/drmaggiecadet"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-1 inline-flex h-11 w-11 items-center justify-center rounded-full border border-lavender text-royal hover:bg-royal hover:text-white hover:scale-110 hover:rotate-[18deg] transition-all duration-500"
            aria-label="Dr. Maggie on Instagram"
          >
            <Instagram size={17} />
          </a>
        </div>

        <div className="mt-14 max-w-3xl mx-auto text-center text-[12px] leading-relaxed text-charcoal/70">
          All content on this website is for educational purposes only and should not be considered
          medical advice. Please consult your physician with any medical concerns.
        </div>

        <div className="mt-10 pt-6 border-t border-lavender/50 text-center text-[11px] tracking-[0.22em] uppercase text-charcoal/75">
          © {new Date().getFullYear()} Dr. Maggie Cadet, MD. All rights reserved.
        </div>
      </div>

      <style>{`
        @keyframes spin {
          to { transform: translateX(-50%) rotate(360deg); }
        }
      `}</style>
    </footer>
  );
}
